import React from 'react';
import { createRoot } from 'react-dom/client';

import TimelineApp from './TimelineApp';

function boot() {
  const view = document.body?.dataset?.activeView ?? '';
  if (String(view) !== 'timeline') return;

  const el = document.getElementById('timelineReactRoot');
  if (!el) {
    // eslint-disable-next-line no-console
    console.error('[Timeline] Missing mount node: #timelineReactRoot');
    return;
  }

  // eslint-disable-next-line no-console
  console.log('[Timeline] entry boot');

  createRoot(el).render(<TimelineApp />);
}

boot();
